import React, { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import Share from 'components/share';
import { COLOR } from 'constants/colors';
import { SuccessBtnWhiteGreenBorder, SuccessButton } from 'components/button';
import styled from 'styled-components';
import { addAgentCode, getName, getPrimaryMobile, redirectToHome } from '__utils/common-utils';
import ConfirmationModal from 'components/confirmation-modal';
import { useDispatch, useSelector } from 'react-redux';
import { propsToJS } from '__utils/immutable-to-js';
import { CommonStyledComponentProps } from '__utils/type';
import resolveURLParams from '__utils/url-params-resolver';
import { ENDPOINTS } from 'constants/endpoints';
import { getDefaultHeaders, post } from '__utils/ajax-wrapper';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import { isProUser, redirectToOld, } from '__utils/common-utils';
import PaymentMode from 'components/payment-mode';
import { hideSharePopupAction } from 'components/share/share.actions';
import GreaterIcon from 'assets/icons/greater-than-icon';
import { ColumnFlexWrapper } from 'views/common-styled-components';
import { ClockIcon } from 'assets/icons/clock-icon';
import PaymentViewSelector from '../payment-flow.selector';
import moment from 'moment';
import { Col, Row } from 'antd';
import useFlashToggler from 'hooks/use-flash-toggler';
import ShareButton from 'components/share-button';


interface CtaProps {
    isPaymentLinkExpired?: boolean;
    validOrdersPresentFlag?: boolean;
    linkValidTill?: string;
    cartId: string;
}

const OuterContainer = styled.div<CommonStyledComponentProps>`
    padding: ${(props) => props.isMobile ? '16px' : ''};
    position: relative;
    .StickyFooter{
        background: #fff;
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 8px;
        box-shadow: 0 2px 4px 4px #E0E0E0;
        z-index: 105;
        display: flex;
        button{
            flex: 1 1 0%;
        }
    }
    .StickyFooterWeb{
        display: flex;
    }
    .webCta{
        width:100%;
        padding: 24px;
        display: flex;
        flex-direction: column;
        margin-top: 16px;
        .webCTAcust{
            width: 160px;
        }
    }
`;

const SubmitButton = styled(SuccessButton) <CommonStyledComponentProps>`
    width: ${(props: any) => props.isMobile ? '' : '100%'};
    &:disabled{
        background: #A1A6A7 !important;
    }
`;


const OrderSummaryCTASection: React.FC<CtaProps> = ({ isPaymentLinkExpired, validOrdersPresentFlag, linkValidTill, cartId }: CtaProps) => {
    const dispatch = useDispatch();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const [showOtpPopup, setShowOtpPopup] = useState<boolean>(false);
    const [invalidOrderPopup, setInvalidOrderPopup] = useState<boolean>(false);
    const { userPaymentDetailView, totalValidOrdersAmount } = propsToJS(useSelector(PaymentViewSelector));
    const flash = useFlashToggler();

    const maskLastDigits = (maskingNo: string) => {
        return maskingNo.substring(0, maskingNo.length - 4).replace(/\d/g, 'X') + maskingNo.substring(maskingNo.length - 4);
    }

    const getShareMessage = () => {
        return window.encodeURIComponent(
            `Dear ${getName()},\n\nAn order for investing *${totalValidOrdersAmount}/-* has been placed on your behalf.\n\nYou can make payments using any of the following mode:\n\n 1. UPI payment \n 2. Net banking \n 3. NEFT/RTGS \n\nPlace order before ${moment(linkValidTill).format('lll')}\nLogin with Registered Mobile No. *${maskLastDigits(getPrimaryMobile())}*\n\nClick here to make the payment- \n${getShareURL()}`);
    }

    const getShareURL = () => {
        var hn = window.location.host;
        if (hn.substring(0, 3) === "pro") hn = hn.substring(4);
        else if (hn.substring(0, 7) === "www.pro") hn = hn.substring(8);
        return `${window.location.protocol}//${hn}/v1/order-summary${window.location.search}`;
    }

    const sharePaymentDetails = (shareTo: string, type: string) => {
        const shareType = type === 'email' ? 'email' : 'sms';
        post(resolveURLParams(`${ENDPOINTS.POST_SHARE_ORDER_SUMMARY_CONTENT}?type=${shareType}&value=${shareTo}&paymentLink=${type === "mobile" ? window.encodeURIComponent(getShareURL()) : getShareURL()}&validityDate=${moment(linkValidTill).format('DD/MM/YYYY')}`, null, {}), {}, getDefaultHeaders(), true)
            .subscribe((response: AjaxResponse | AjaxError) => {
                if (response?.response?.meta?.message === 'success') {
                    flash.success('Payment link shared successfully!!!');
                    dispatch(hideSharePopupAction());
                }

            }, (error: AjaxError) => {
                flash.error("Failed to share payment link. Please try again later.");
                dispatch(hideSharePopupAction());
            });
    }

    const getFlashMessage = () => {
        return (
            <ColumnFlexWrapper bgColor={COLOR.WARNING_LIGHT} gap={'4px'}>
                <ClockIcon />
                <div>The link will be valid till {linkValidTill && moment(linkValidTill).format('lll')} .</div>
            </ColumnFlexWrapper>
        )
    }

    const ErrorContent = () => {
        return (
            <div>
                <p>
                    <span><b>Thank you for reporting the error.</b> <br />Turtlemint Money Expert will call you shortly.</span>
                </p><br />
                <div className="fl-left pb16">
                    <SuccessBtnWhiteGreenBorder onClick={() => redirectToHome()}>Back to Home page     <GreaterIcon color={COLOR.GREEN} /> </SuccessBtnWhiteGreenBorder>
                </div>
                <div style={{ clear: "both" }}></div>
            </div>
        );
    }

    const reportInvalidOrders = () => {
        setInvalidOrderPopup(true);
        const invalidData = {
            orderDetailsList: userPaymentDetailView,
        }
        post(ENDPOINTS.POST_REPORT_INVALID_ORDERS, invalidData, getDefaultHeaders(), true)
            .subscribe((response: AjaxResponse | AjaxError) => {
            }, (error: AjaxError) => {
            });
    }

    return (
        <OuterContainer isMobile={isMobile}>

            <div className={isMobile ? "StickyFooter" : "StickyFooterWeb webCta mint-box"}>
                {(!isMobile && totalValidOrdersAmount > 0) && <Row style={{ justifyContent: 'space-between', marginBottom: '16px' }}>
                    <Col style={{ color: '#4d5556', fontSize: '18px' }}>
                        Total Amount :
                    </Col>
                    <Col >
                        <b className='totalAmountTitle'> ₹ {totalValidOrdersAmount?.toLocaleString(navigator.language, { minimumFractionDigits: 2 })}</b>
                    </Col>
                </Row>}

                {
                    isPaymentLinkExpired ?
                        <SubmitButton isMobile={isMobile} onClick={() => redirectToOld(addAgentCode('cart-review'))}>Go to Cart</SubmitButton>
                        :
                        (validOrdersPresentFlag ?
                            <>
                                {isMobile && <b className='totalAmountTitleMobile'>Total Amount : ₹ {totalValidOrdersAmount?.toLocaleString(navigator.language, { minimumFractionDigits: 2 })}</b>}
                                {isProUser() &&
                                    <div style={{ marginBottom: !isMobile ? '16px' : '' }}>
                                        <ShareButton
                                            shareConfig={
                                                {
                                                    message: getShareMessage(),
                                                    shareUrl: getShareURL(),
                                                    onEmailOrSMSShare: sharePaymentDetails,
                                                    shareType: `sharePaymentDetails`,
                                                    customHeader: <h3 style={{ marginBottom: '12px' }}>{`Share Payment Link with ${getName()}`}</h3>,
                                                    flashMessage: getFlashMessage(),
                                                    mixpanelData: { eventName: 'orderSummaryShare', source: 'orderSummary' }
                                                }}
                                        />
                                    </div>
                                }                                
                                < SubmitButton isMobile={isMobile} onClick={() => setShowOtpPopup(true)}>Proceed to Payment</SubmitButton>
                            </> :
                            <SubmitButton isMobile={isMobile} onClick={() => reportInvalidOrders()}>Report Error</SubmitButton>)
                }
            </div>
            {showOtpPopup && <PaymentMode onClose={() => setShowOtpPopup(false)} cartId={cartId} />}
            {invalidOrderPopup && <ConfirmationModal title="Oh Snap!" customHeader modalBody={<ErrorContent />} closable={false}></ConfirmationModal>}

        </OuterContainer >

    )
}

export default OrderSummaryCTASection;

